import { createRouter, createRoute, createRootRoute } from '@tanstack/react-router'
import Layout from './components/common/Layout'
import HomePage from './pages/HomePage'
import TripPage from './pages/TripPage'
import DashboardPage from './pages/DashboardPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import TopDestinationsPage from './pages/seo/TopDestinationsPage'
import ItalyItineraryPage from './pages/seo/ItalyItineraryPage'
import SpainItineraryPage from './pages/seo/SpainItineraryPage'
import ImprintPage from './pages/ImprintPage'
import PortugalItineraryPage from './pages/seo/PortugalItineraryPage'
import IndonesiaItineraryPage from './pages/seo/IndonesiaItineraryPage'
import GermanyItineraryPage from './pages/seo/GermanyItineraryPage'
import DubaiItineraryPage from './pages/seo/DubaiItineraryPage'
import DiscoverPage from './pages/DiscoverPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import NotFoundPage from './pages/NotFoundPage'
import AdminPage from './pages/AdminPage'

import i18n from './i18n/config'

// Root route (layout wrapper)
const rootRoute = createRootRoute({
    component: Layout,
})

// Helper to create both default and localized versions of a route
// We use absolute paths for both to avoid TanStack Router path resolution issues with nested routes
const createDualRoutes = (path: string, component: any) => {
    const defaultRoute = createRoute({
        getParentRoute: () => rootRoute,
        path,
        component,
    });

    // For localized route, we prefix with $lang
    // If path is '/', it becomes '/$lang'
    const localizedPath = path === '/' ? '/$lang' : `/$lang${path}`;

    const localizedRoute = createRoute({
        getParentRoute: () => rootRoute,
        path: localizedPath,
        component,
        beforeLoad: ({ params }: any) => {
            if (['ro', 'en'].includes(params.lang)) {
                i18n.changeLanguage(params.lang);
            }
        }
    });

    return [defaultRoute, localizedRoute];
};

const routes = [
    ...createDualRoutes('/', HomePage),
    ...createDualRoutes('/trip/$slug', TripPage),
    ...createDualRoutes('/dashboard', DashboardPage),
    ...createDualRoutes('/admin', AdminPage),
    ...createDualRoutes('/about', AboutPage),
    ...createDualRoutes('/contact', ContactPage),
    ...createDualRoutes('/terms', TermsPage),
    ...createDualRoutes('/privacy', PrivacyPage),
    ...createDualRoutes('/cookies', CookiePolicyPage),
    ...createDualRoutes('/imprint', ImprintPage),
    ...createDualRoutes('/blog', BlogPage),
    ...createDualRoutes('/blog/$postId', BlogPostPage),
    ...createDualRoutes('/discover', DiscoverPage),
    ...createDualRoutes('/top-destinations', TopDestinationsPage),
    ...createDualRoutes('/italy', ItalyItineraryPage),
    ...createDualRoutes('/spain', SpainItineraryPage),
    ...createDualRoutes('/portugal', PortugalItineraryPage),
    ...createDualRoutes('/indonesia', IndonesiaItineraryPage),
    ...createDualRoutes('/germany', GermanyItineraryPage),
    ...createDualRoutes('/dubai', DubaiItineraryPage),
];

// Create router
const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
    routeTree,
    defaultNotFoundComponent: NotFoundPage
})

// Type declaration for router
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}
